import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import groundFloorImage from '../../../assets/images/MapImages/belapur_ground.png';
import firstFloorImage from '../../../assets/images/MapImages/belapur_first.png';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import dombivliStoreImage from '../../../assets/images/MapImages/dombivli_store.png';

const FloorToggle = () => {
  const [activeFloor, setActiveFloor] = useState('Ground');
  const source = (localStorage.getItem('source'));
  const isBealpur = source === 'bealpur-001';
  const isDombivli = source === 'dombivli';

  const handleFloorChange = (floor) => {
    setActiveFloor(floor);
  };

  return (
    <>
      {isBealpur && (
        /* Floor toggle buttons - only show for Bealpur */
        <Box sx={{ position: 'absolute', top: 0, right: 0, zIndex: 10, display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Button
            variant={activeFloor === 'Ground' ? 'contained' : 'outlined'}
            color="primary"
            onClick={() => handleFloorChange('Ground')}
            size="small"
          >
            G
          </Button>
          <Button
            variant={activeFloor === 'First' ? 'contained' : 'outlined'}
            color="primary"
            onClick={() => handleFloorChange('First')}
            size="small"
          >
            1
          </Button>
        </Box>
      )}

      {/* Floor plan display */}
      <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
        {isBealpur ? (
          <TransformWrapper
            initialScale={1}
            minScale={0.5}
            maxScale={5}
            wheel={{ step: 0.1 }}
            doubleClick={{ disabled: true }}
          >
            {({ zoomIn, zoomOut, resetTransform }) => (
              <>
                <Box sx={{ position: 'absolute', top: 10, left: 10, zIndex: 10, display: 'flex', gap: 1 }}>
                  <Button variant="contained" size="small" onClick={() => zoomIn()} sx={{ minWidth: '32px' }}>+</Button>
                  <Button variant="contained" size="small" onClick={() => zoomOut()} sx={{ minWidth: '32px' }}>-</Button>
                  <Button variant="contained" size="small" onClick={() => resetTransform()}>Reset</Button>
                </Box>
                <TransformComponent 
                  wrapperStyle={{ 
                    width: '100%', 
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }} 
                  contentStyle={{ 
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                  }}
                >
                  {activeFloor === 'Ground' ? (
                    <img
                      src={groundFloorImage}
                      alt="Ground Floor Plan"
                      style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                    />
                  ) : (
                    <img
                      src={firstFloorImage}
                      alt="First Floor Plan"
                      style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                    />
                  )}
                </TransformComponent>
              </>
            )}
          </TransformWrapper>
        ) : isDombivli ? (
          <TransformWrapper
            initialScale={1}
            minScale={0.5}
            maxScale={5}
            wheel={{ step: 0.1 }}
            doubleClick={{ disabled: true }}
          >
            {({ zoomIn, zoomOut, resetTransform }) => (
              <>
                <Box sx={{ position: 'absolute', top: 10, left: 10, zIndex: 10, display: 'flex', gap: 1 }}>
                  <Button variant="contained" size="small" onClick={() => zoomIn()} sx={{ minWidth: '32px' }}>+</Button>
                  <Button variant="contained" size="small" onClick={() => zoomOut()} sx={{ minWidth: '32px' }}>-</Button>
                  <Button variant="contained" size="small" onClick={() => resetTransform()}>Reset</Button>
                </Box>
                <TransformComponent 
                  wrapperStyle={{ 
                    width: '100%', 
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }} 
                  contentStyle={{ 
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                  }}
                >
                  <img
                    src={dombivliStoreImage}
                    alt="Dombivli Store Plan"
                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                  />
                </TransformComponent>
              </>
            )}
          </TransformWrapper>
        ) : (
          /* Existing 'Map not available' message */
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%',
            backgroundColor: '#f5f5f5',
            borderRadius: '8px',
            padding: '20px'
          }}>
            <Typography variant="h5" sx={{ color: '#64748b', marginBottom: '10px' }}>
              Floor Map Not Available
            </Typography>
            <Typography variant="body1" sx={{ color: '#94a3b8', textAlign: 'center' }}>
              Floor maps are only available for certain stores.
            </Typography>
          </Box>
        )}

        {/* Floor indicator */}
        {isBealpur && (
          <Typography
            variant="h6"
            sx={{
              position: 'absolute',
              bottom: 10,
              left: 10,
              backgroundColor: 'rgba(255,255,255,0.7)',
              padding: '4px 8px',
              borderRadius: '4px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
              zIndex: 10
            }}
          >
            {activeFloor} Floor
          </Typography>
        )}
      </Box>
    </>
  );
};

export default FloorToggle;
